import * as CommonUtils from '../../utils/common';
import FilterConstants from '../../filter-constants';
import Series from './series';
import { normalizeToPreferredSeries } from '@ebiz/aditools-filter';

// get the tolerance config where the idealValue fits.
// This goes from the selected tolerance up to the bigger tolerance percentages.
// Each tolerance config will have their own
export function getToleranceConfig(listOfConfigs, idealValue, selectedTolerance) {
  var toleranceConfig = listOfConfigs.find((item) => {
    return item.name === selectedTolerance;
  });
  if (CommonUtils.isNullOrUndefined(toleranceConfig)) throw `unknown selectedTolerance ${selectedTolerance}`;

  let result = null;
  var indexOfToleranceConfig = listOfConfigs.indexOf(toleranceConfig);
  for (let i = indexOfToleranceConfig; i < listOfConfigs.length; i++) {
    let currentRow = listOfConfigs[i];
    let allowedMin = currentRow.allowedMin;
    let allowedMax = currentRow.allowedMax;

    if (idealValue + 0.00000000000000000001 >= allowedMin && idealValue - 0.00000000000000000001 <= allowedMax) {
      result = currentRow;
      break;
    }
  }

  return result;
}

export function computeNominalValue(desiredValue, preferredSeries, roundDirection) {
  if (preferredSeries === 'ideal') {
    const exponent = getExponent(desiredValue);
    const nominalValue = getBaseValue(desiredValue);
    return parseFloat(nominalValue.toString() + exponent);
  }

  return normalizeToPreferredSeries(desiredValue, preferredSeries, { forceRoundDirection: roundDirection });
}

// export function computeNominalValue(desiredValue, preferredSeries, forceRoundDirection) {
//   let desiredVal = getBaseValue(desiredValue);
//   let nominalValue = desiredVal;
//   if (preferredSeries === 'NA') nominalValue = desiredVal;
//   else {
//     for (var i = 0; i < preferredSeries.length; i++) {
//       if (preferredSeries[i] <= desiredVal && desiredVal < preferredSeries[i + 1]) {
//         var distanceBelow = desiredVal / preferredSeries[i];
//         var distanceAbove = preferredSeries[i + 1] / desiredVal;

//         if (forceRoundDirection === FilterConstants.roundDirection.down && distanceAbove > 1) {
//           nominalValue = preferredSeries[i];
//         } else if (forceRoundDirection === FilterConstants.roundDirection.up && distanceBelow > 1) {
//           nominalValue = preferredSeries[i + 1];
//         }
//         //round to closest
//         else {
//           if (distanceBelow < distanceAbove) {
//             nominalValue = preferredSeries[i];
//           } else if (distanceAbove < distanceBelow) {
//             nominalValue = preferredSeries[i + 1];
//           }
//         }

//         break;
//       }
//     }
//   }

//   let exponent = getExponent(desiredValue);
//   nominalValue = nominalValue.toString() + exponent;
//   let result = parseFloat(nominalValue);
//   return result;
// }

export function getToleranceArray(value, toleranceConfig) {
  var multiplicationFactors = toleranceConfig.multiplicationFactors;
  var result = multiplicationFactors.map((item) => {
    var res = value * item;
    return res;
  });

  return result;
}

export function getSeries(selectedSeries) {
  var result = 'NA';
  switch (selectedSeries) {
    case FilterConstants.eSeries.E6:
      result = Series.eSeries6;
      break;
    case FilterConstants.eSeries.E12:
      result = Series.eSeries12;
      break;
    case FilterConstants.eSeries.E24:
      result = Series.eSeries24;
      break;
    case FilterConstants.eSeries.E48:
      result = Series.eSeries48;
      break;
    case FilterConstants.eSeries.E96:
      result = Series.eSeries96;
      break;
  }

  return result;
}

/// Given 11e-3, this will get 11
function getBaseValue(idealValue) {
  let scientificNotation = idealValue.toExponential().toString();
  var indexOfE = scientificNotation.indexOf('e');
  let baseValue = parseFloat(scientificNotation.slice(0, indexOfE));

  return baseValue;
}

/// Given 11e-3, this will get e-3
function getExponent(idealValue) {
  let scientificNotation = idealValue.toExponential().toString();
  var stringLength = scientificNotation.length;
  var indexOfE = scientificNotation.indexOf('e');

  let exponent = scientificNotation.slice(indexOfE, stringLength);
  return exponent;
}
